import { useMemo, useRef, useState } from "react";
import { useQuery } from "react-query";

import { CCard, CCardBody } from "@coreui/react";

import { CTable } from "src/1/common/components/others";
import { history } from "src/App";
import { CActionGroup } from "src/common/components/others";
import { format } from "src/utils/dayjs";

import { khoTrungTamApi } from "_1/apis/kho_trung_tam.api";

import { useTitle } from "../../../../utils/hooks/title";
import { TaoPhieuChamDiemKTT } from "../../components";

export default function DSPhieuChamDiemKTT() {
  useTitle("DS phiếu chấm điểm KTT");

  //#region Data
  const [params, setParams] = useState({ page: 1, size: 10 });

  const { data, refetch } = useQuery({
    queryKey: ["danh-sach-phieu-cham-diem-ktt", params],
    queryFn: () => khoTrungTamApi.getPaginate(params),
    select: (res) => res.data,
  });

  const listData = useMemo(() => data?.data || [], [data]);
  const metadata = useMemo(() => data?.metadata || [], [data]);

  const modalRef = useRef(null);
  //#endregion

  //#region Event
  const onLimitChange = (newLimit) =>
    setParams((prev) => ({
      ...prev,
      page: 1,
      size: newLimit,
    }));

  const onPageChange = (newPage) =>
    setParams((prev) => ({
      ...prev,
      page: newPage,
    }));

  const handleClick = () => modalRef.current?.open();
  //#endregion

  //#region Render
  const headers = [
    {
      key: "code",
      label: "Mã",
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() => history.push(`/central/form/${record.id}`)}
        >
          {value}
        </span>
      ),
    },
    { key: "cycle", label: "Kỳ đánh giá" },
    {
      key: "evaluation_date",
      label: "Ngày đánh giá",
      cellRender: (value) => format(value, "DD/MM/YYYY"),
    },
    { key: "submitted_stores", label: "Số CN đã đánh giá" },
    { key: "year", label: "Năm" },
  ];
  return (
    <>
      <CCard>
        <CCardBody>
          <CActionGroup onClick={handleClick} />
        </CCardBody>
      </CCard>
      <CCard>
        <CCardBody className="px-0">
          <CTable
            headers={headers}
            data={listData}
            divider
            fontSizeBody={16}
            page={params.page}
            pages={metadata?.last_page}
            limit={params.size}
            total={metadata?.total}
            onPageChange={onPageChange}
            onLimitChange={onLimitChange}
          />
        </CCardBody>
      </CCard>

      <TaoPhieuChamDiemKTT ref={modalRef} refetch={refetch} />
    </>
  );
  //#endregion
}
